module.exports = __webpack_public_path__ + "static/img/img_form_2_ja.a5c03ddb.png";